import { ConfirmSheet } from '@/components/ConfirmSheet'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
} from '@/components/ModalSheet'

export interface RevertDialogProps {
  showing: boolean
  version: number
  onConfirm: () => void
  onDecline: () => void
  confirmButtonTestId?: string
}

/**
 * Asks to confirm resetting the draft to an older version.
 */
export function RevertDialog({
  showing,
  version,
  onConfirm,
  onDecline,
  confirmButtonTestId,
}: RevertDialogProps) {
  return (
    <ConfirmSheet
      title="Confirm revert"
      yes="Revert"
      danger
      showing={showing}
      onConfirm={onConfirm}
      onDecline={onDecline}
      confirmButtonTestId={confirmButtonTestId}
    >
      <ModalSheetContentBlock>
        <ModalSheetContentDescription>
          This will reset the current draft to the exact state of{' '}
          <strong>V{version}</strong>.
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>
    </ConfirmSheet>
  )
}
